module.exports = __webpack_public_path__ + "img/sortIcons.2f6f4e48.svg";